var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0 0H1920V1080H0V0Z",
    fill: "url(#paint0_linear_2492_14458)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2492_14458)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip1_2492_14458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0975 896C-48.4557 896 -112 959.544 -112 1038.1C-112 1116.46 -48.4557 1180.19 30.0975 1180.19C108.456 1180.19 172.195 1116.65 172.195 1038.1C172 959.544 108.456 896 30.0975 896ZM30.0975 1171.03C-43.3878 1171.03 -102.839 1111.58 -102.839 1038.1C-102.839 964.612 -43.3878 905.161 30.0975 905.161C103.583 905.161 163.034 964.612 163.034 1038.1C163.034 1111.39 103.388 1171.03 30.0975 1171.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0988 926.603C-31.3014 926.603 -81.2012 976.502 -81.2012 1037.9C-81.2012 1099.3 -31.3014 1149.2 30.0988 1149.2C91.4989 1149.2 141.399 1099.5 141.399 1038.1C141.399 976.502 91.4989 926.603 30.0988 926.603ZM30.0988 1132.24C-21.9452 1132.24 -64.243 1089.95 -64.243 1037.9C-64.243 985.859 -21.9452 943.561 30.0988 943.561C82.1427 943.561 124.441 985.859 124.441 1037.9C124.441 1089.95 82.1427 1132.24 30.0988 1132.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.098 975.527C-4.40304 975.527 -32.4717 1003.6 -32.4717 1038.1C-32.4717 1072.6 -4.59796 1100.67 30.098 1100.67C64.599 1100.67 92.6677 1072.6 92.6677 1038.1C92.4727 1003.6 64.599 975.527 30.098 975.527ZM30.098 1071.62C11.5805 1071.62 -3.42843 1056.61 -3.42843 1038.1C-3.42843 1019.58 11.5805 1004.57 30.098 1004.57C48.6155 1004.57 63.6244 1019.58 63.6244 1038.1C63.6244 1056.61 48.6155 1071.62 30.098 1071.62Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip2_2492_14458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1768.34 789.264C1768.34 790.784 1767.19 791.923 1765.67 791.923C1764.14 791.923 1763 790.784 1763 789.264C1763 787.745 1764.14 786.605 1765.67 786.605C1767.19 786.605 1768.34 787.872 1768.34 789.264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1791.08 789.264C1791.08 790.784 1789.93 791.923 1788.41 791.923C1786.88 791.923 1785.74 790.784 1785.74 789.264C1785.74 787.745 1786.88 786.605 1788.41 786.605C1789.8 786.605 1791.08 787.872 1791.08 789.264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1813.69 789.264C1813.69 790.784 1812.54 791.923 1811.02 791.923C1809.5 791.923 1808.35 790.784 1808.35 789.264C1808.35 787.745 1809.5 786.605 1811.02 786.605C1812.54 786.605 1813.69 787.872 1813.69 789.264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.43 789.264C1836.43 790.784 1835.28 791.923 1833.76 791.923C1832.24 791.923 1831.09 790.784 1831.09 789.264C1831.09 787.745 1832.24 786.605 1833.76 786.605C1835.28 786.605 1836.43 787.872 1836.43 789.264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1859.17 789.264C1859.17 790.784 1858.02 791.923 1856.5 791.923C1854.98 791.923 1853.83 790.784 1853.83 789.264C1853.83 787.745 1854.98 786.605 1856.5 786.605C1857.9 786.605 1859.17 787.872 1859.17 789.264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.91 789.264C1881.91 790.784 1880.76 791.923 1879.24 791.923C1877.72 791.923 1876.57 790.784 1876.57 789.264C1876.57 787.745 1877.72 786.605 1879.24 786.605C1880.76 786.605 1881.91 787.872 1881.91 789.264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1904.52 789.264C1904.52 790.784 1903.38 791.923 1901.85 791.923C1900.33 791.923 1899.18 790.784 1899.18 789.264C1899.18 787.745 1900.33 786.605 1901.85 786.605C1903.38 786.605 1904.52 787.872 1904.52 789.264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.34 808.131C1768.34 809.65 1767.19 810.79 1765.67 810.79C1764.14 810.79 1763 809.65 1763 808.131C1763 806.611 1764.14 805.472 1765.67 805.472C1767.19 805.472 1768.34 806.611 1768.34 808.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1791.08 808.131C1791.08 809.65 1789.93 810.79 1788.41 810.79C1786.88 810.79 1785.74 809.65 1785.74 808.131C1785.74 806.611 1786.88 805.472 1788.41 805.472C1789.8 805.472 1791.08 806.611 1791.08 808.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1813.69 808.131C1813.69 809.65 1812.54 810.79 1811.02 810.79C1809.5 810.79 1808.35 809.65 1808.35 808.131C1808.35 806.611 1809.5 805.472 1811.02 805.472C1812.54 805.472 1813.69 806.611 1813.69 808.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.43 808.131C1836.43 809.65 1835.28 810.79 1833.76 810.79C1832.24 810.79 1831.09 809.65 1831.09 808.131C1831.09 806.611 1832.24 805.472 1833.76 805.472C1835.28 805.472 1836.43 806.611 1836.43 808.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1859.17 808.131C1859.17 809.65 1858.02 810.79 1856.5 810.79C1854.98 810.79 1853.83 809.65 1853.83 808.131C1853.83 806.611 1854.98 805.472 1856.5 805.472C1857.9 805.472 1859.17 806.611 1859.17 808.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.91 808.131C1881.91 809.65 1880.76 810.79 1879.24 810.79C1877.72 810.79 1876.57 809.65 1876.57 808.131C1876.57 806.611 1877.72 805.472 1879.24 805.472C1880.76 805.472 1881.91 806.611 1881.91 808.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1904.52 808.131C1904.52 809.65 1903.38 810.79 1901.85 810.79C1900.33 810.79 1899.18 809.65 1899.18 808.131C1899.18 806.611 1900.33 805.472 1901.85 805.472C1903.38 805.472 1904.52 806.611 1904.52 808.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.34 751.659C1768.34 753.178 1767.19 754.318 1765.67 754.318C1764.14 754.318 1763 753.178 1763 751.659C1763 750.14 1764.14 749 1765.67 749C1767.19 749 1768.34 750.14 1768.34 751.659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1791.08 751.659C1791.08 753.178 1789.93 754.318 1788.41 754.318C1786.88 754.318 1785.74 753.178 1785.74 751.659C1785.74 750.14 1786.88 749 1788.41 749C1789.8 749 1791.08 750.14 1791.08 751.659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1813.69 751.659C1813.69 753.178 1812.54 754.318 1811.02 754.318C1809.5 754.318 1808.35 753.178 1808.35 751.659C1808.35 750.14 1809.62 749 1811.02 749C1812.54 749 1813.69 750.14 1813.69 751.659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.43 751.659C1836.43 753.178 1835.28 754.318 1833.76 754.318C1832.24 754.318 1831.09 753.178 1831.09 751.659C1831.09 750.14 1832.36 749 1833.76 749C1835.16 749 1836.43 750.14 1836.43 751.659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1859.17 751.659C1859.17 753.178 1858.02 754.318 1856.5 754.318C1854.98 754.318 1853.83 753.178 1853.83 751.659C1853.83 750.14 1854.98 749 1856.5 749C1857.9 749 1859.17 750.14 1859.17 751.659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.91 751.659C1881.91 753.178 1880.76 754.318 1879.24 754.318C1877.72 754.318 1876.57 753.178 1876.57 751.659C1876.57 750.14 1877.72 749 1879.24 749C1880.76 749 1881.91 750.14 1881.91 751.659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1904.52 751.659C1904.52 753.178 1903.38 754.318 1901.85 754.318C1900.33 754.318 1899.18 753.178 1899.18 751.659C1899.18 750.14 1900.33 749 1901.85 749C1903.38 749 1904.52 750.14 1904.52 751.659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.34 770.525C1768.34 772.045 1767.19 773.184 1765.67 773.184C1764.14 773.184 1763 771.918 1763 770.525C1763 769.006 1764.14 767.866 1765.67 767.866C1767.19 767.866 1768.34 769.006 1768.34 770.525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1791.08 770.525C1791.08 772.045 1789.93 773.184 1788.41 773.184C1786.88 773.184 1785.74 772.045 1785.74 770.525C1785.74 769.006 1786.88 767.866 1788.41 767.866C1789.8 767.866 1791.08 769.006 1791.08 770.525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1813.69 770.525C1813.69 772.045 1812.54 773.184 1811.02 773.184C1809.5 773.184 1808.35 772.045 1808.35 770.525C1808.35 769.006 1809.5 767.866 1811.02 767.866C1812.54 767.866 1813.69 769.006 1813.69 770.525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.43 770.525C1836.43 772.045 1835.28 773.184 1833.76 773.184C1832.24 773.184 1831.09 772.045 1831.09 770.525C1831.09 769.006 1832.24 767.866 1833.76 767.866C1835.28 767.866 1836.43 769.006 1836.43 770.525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1859.17 770.525C1859.17 772.045 1858.02 773.184 1856.5 773.184C1854.98 773.184 1853.83 772.045 1853.83 770.525C1853.83 769.006 1854.98 767.866 1856.5 767.866C1857.9 767.866 1859.17 769.006 1859.17 770.525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.91 770.525C1881.91 772.045 1880.76 773.184 1879.24 773.184C1877.72 773.184 1876.57 772.045 1876.57 770.525C1876.57 769.006 1877.72 767.866 1879.24 767.866C1880.76 767.866 1881.91 769.006 1881.91 770.525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1904.52 770.525C1904.52 772.045 1903.38 773.184 1901.85 773.184C1900.33 773.184 1899.18 772.045 1899.18 770.525C1899.18 769.006 1900.33 767.866 1901.85 767.866C1903.38 767.866 1904.52 769.006 1904.52 770.525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.34 826.87C1768.34 828.389 1767.19 829.529 1765.67 829.529C1764.14 829.529 1763 828.389 1763 826.87C1763 825.35 1764.14 824.211 1765.67 824.211C1767.19 824.211 1768.34 825.477 1768.34 826.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1791.08 826.87C1791.08 828.389 1789.93 829.529 1788.41 829.529C1786.88 829.529 1785.74 828.389 1785.74 826.87C1785.74 825.35 1786.88 824.211 1788.41 824.211C1789.8 824.211 1791.08 825.477 1791.08 826.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1813.69 826.87C1813.69 828.389 1812.54 829.529 1811.02 829.529C1809.5 829.529 1808.35 828.389 1808.35 826.87C1808.35 825.35 1809.5 824.211 1811.02 824.211C1812.54 824.211 1813.69 825.477 1813.69 826.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.43 826.87C1836.43 828.389 1835.28 829.529 1833.76 829.529C1832.24 829.529 1831.09 828.389 1831.09 826.87C1831.09 825.35 1832.24 824.211 1833.76 824.211C1835.28 824.211 1836.43 825.477 1836.43 826.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1859.17 826.87C1859.17 828.389 1858.02 829.529 1856.5 829.529C1854.98 829.529 1853.83 828.389 1853.83 826.87C1853.83 825.35 1854.98 824.211 1856.5 824.211C1857.9 824.211 1859.17 825.477 1859.17 826.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.91 826.87C1881.91 828.389 1880.76 829.529 1879.24 829.529C1877.72 829.529 1876.57 828.389 1876.57 826.87C1876.57 825.35 1877.72 824.211 1879.24 824.211C1880.76 824.211 1881.91 825.477 1881.91 826.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1904.52 826.87C1904.52 828.389 1903.38 829.529 1901.85 829.529C1900.33 829.529 1899.18 828.389 1899.18 826.87C1899.18 825.35 1900.33 824.211 1901.85 824.211C1903.38 824.211 1904.52 825.477 1904.52 826.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.34 845.736C1768.34 847.256 1767.19 848.395 1765.67 848.395C1764.14 848.395 1763 847.256 1763 845.736C1763 844.217 1764.14 843.077 1765.67 843.077C1767.19 843.077 1768.34 844.217 1768.34 845.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1791.08 845.736C1791.08 847.256 1789.93 848.395 1788.41 848.395C1786.88 848.395 1785.74 847.256 1785.74 845.736C1785.74 844.217 1786.88 843.077 1788.41 843.077C1789.8 843.077 1791.08 844.217 1791.08 845.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1813.69 845.736C1813.69 847.256 1812.54 848.395 1811.02 848.395C1809.5 848.395 1808.35 847.256 1808.35 845.736C1808.35 844.217 1809.5 843.077 1811.02 843.077C1812.54 843.077 1813.69 844.217 1813.69 845.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1833.76 848.395C1835.23 848.395 1836.43 847.205 1836.43 845.736C1836.43 844.268 1835.23 843.077 1833.76 843.077C1832.29 843.077 1831.09 844.268 1831.09 845.736C1831.09 847.205 1832.29 848.395 1833.76 848.395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1859.17 845.736C1859.17 847.256 1858.02 848.395 1856.5 848.395C1854.98 848.395 1853.83 847.256 1853.83 845.736C1853.83 844.217 1854.98 843.077 1856.5 843.077C1857.9 843.077 1859.17 844.217 1859.17 845.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.91 845.736C1881.91 847.256 1880.76 848.395 1879.24 848.395C1877.72 848.395 1876.57 847.256 1876.57 845.736C1876.57 844.217 1877.72 843.077 1879.24 843.077C1880.76 843.077 1881.91 844.217 1881.91 845.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1904.52 845.736C1904.52 847.256 1903.38 848.395 1901.85 848.395C1900.33 848.395 1899.18 847.256 1899.18 845.736C1899.18 844.217 1900.33 843.077 1901.85 843.077C1903.38 843.077 1904.52 844.217 1904.52 845.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.34 864.601C1768.34 866.121 1767.19 867.26 1765.67 867.26C1764.14 867.26 1763 866.121 1763 864.601C1763 863.082 1764.14 861.942 1765.67 861.942C1767.19 861.942 1768.34 863.082 1768.34 864.601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1791.08 864.601C1791.08 866.121 1789.93 867.26 1788.41 867.26C1786.88 867.26 1785.74 866.121 1785.74 864.601C1785.74 863.082 1786.88 861.942 1788.41 861.942C1789.8 861.942 1791.08 863.082 1791.08 864.601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1813.69 864.601C1813.69 866.121 1812.54 867.26 1811.02 867.26C1809.5 867.26 1808.35 866.121 1808.35 864.601C1808.35 863.082 1809.5 861.942 1811.02 861.942C1812.54 861.942 1813.69 863.082 1813.69 864.601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.43 864.601C1836.43 866.121 1835.28 867.26 1833.76 867.26C1832.24 867.26 1831.09 866.121 1831.09 864.601C1831.09 863.082 1832.24 861.942 1833.76 861.942C1835.28 861.942 1836.43 863.082 1836.43 864.601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1859.17 864.601C1859.17 866.121 1858.02 867.26 1856.5 867.26C1854.98 867.26 1853.83 866.121 1853.83 864.601C1853.83 863.082 1854.98 861.942 1856.5 861.942C1857.9 861.942 1859.17 863.082 1859.17 864.601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.91 864.601C1881.91 866.121 1880.76 867.26 1879.24 867.26C1877.72 867.26 1876.57 866.121 1876.57 864.601C1876.57 863.082 1877.72 861.942 1879.24 861.942C1880.76 861.942 1881.91 863.082 1881.91 864.601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1904.52 864.601C1904.52 866.121 1903.38 867.26 1901.85 867.26C1900.33 867.26 1899.18 866.121 1899.18 864.601C1899.18 863.082 1900.33 861.942 1901.85 861.942C1903.38 861.942 1904.52 863.082 1904.52 864.601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.34 883.341C1768.34 884.86 1767.19 886 1765.67 886C1764.14 886 1763 884.86 1763 883.341C1763 881.821 1764.14 880.682 1765.67 880.682C1767.19 880.682 1768.34 881.948 1768.34 883.341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1791.08 883.341C1791.08 884.86 1789.93 886 1788.41 886C1786.88 886 1785.74 884.86 1785.74 883.341C1785.74 881.821 1786.88 880.682 1788.41 880.682C1789.8 880.682 1791.08 881.948 1791.08 883.341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1813.69 883.341C1813.69 884.86 1812.54 886 1811.02 886C1809.5 886 1808.35 884.86 1808.35 883.341C1808.35 881.821 1809.5 880.682 1811.02 880.682C1812.54 880.682 1813.69 881.948 1813.69 883.341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1836.43 883.341C1836.43 884.86 1835.28 886 1833.76 886C1832.24 886 1831.09 884.86 1831.09 883.341C1831.09 881.821 1832.24 880.682 1833.76 880.682C1835.28 880.682 1836.43 881.948 1836.43 883.341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1859.17 883.341C1859.17 884.86 1858.02 886 1856.5 886C1854.98 886 1853.83 884.86 1853.83 883.341C1853.83 881.821 1854.98 880.682 1856.5 880.682C1857.9 880.682 1859.17 881.948 1859.17 883.341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.91 883.341C1881.91 884.86 1880.76 886 1879.24 886C1877.72 886 1876.57 884.86 1876.57 883.341C1876.57 881.821 1877.72 880.682 1879.24 880.682C1880.76 880.682 1881.91 881.948 1881.91 883.341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1904.52 883.341C1904.52 884.86 1903.38 886 1901.85 886C1900.33 886 1899.18 884.86 1899.18 883.341C1899.18 881.821 1900.33 880.682 1901.85 880.682C1903.38 880.682 1904.52 881.948 1904.52 883.341Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1761.81 75.2212L1771.47 84.8799L1745.78 110.563L1720.1 84.8799L1729.68 75.2943L1745.71 91.319L1761.81 75.2212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1761.81 40.5386L1771.39 50.1241L1745.71 75.8075L1720.1 50.1973L1729.76 40.5386L1745.78 56.5632L1761.81 40.5386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1761.73 5.78165L1771.39 15.4404L1745.78 41.0506L1720.1 15.3672L1729.68 5.78165L1745.71 21.8063L1761.73 5.78165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1761.81 -28.9761L1771.46 -19.3174L1745.78 6.36601L1720.1 -19.3174L1729.76 -28.9761L1745.78 -12.9514L1761.81 -28.9761Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M794 808.553C780.071 822.482 757.377 822.482 743.447 808.553C729.518 794.623 729.518 771.929 743.447 758L794 808.553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M848.486 529.89C859.205 529.89 867.937 521.165 867.937 510.453C867.937 499.742 859.205 491.017 848.486 491.017L848.486 529.89Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.141 529.89C828.861 529.89 837.592 521.165 837.592 510.453C837.592 499.742 828.861 491.017 818.141 491.017L818.141 529.89Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.796 529.89C798.515 529.89 807.247 521.165 807.247 510.453C807.247 499.742 798.515 491.017 787.796 491.017V529.89Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.301 144.921L146.301 133L178 133L178 164.699L166.169 164.699L166.169 144.921L146.301 144.921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.898 166.325L124.898 154.494L156.597 154.494L156.597 186.103L144.676 186.103L144.676 166.325L124.898 166.325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.495 187.819L103.495 175.898L135.103 175.898L135.103 207.597L123.272 207.597L123.272 187.819L103.495 187.819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0005 209.222L82.0004 197.301L113.699 197.301L113.699 229L101.778 229L101.778 209.222L82.0005 209.222Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2492_14458",
    x1: -0.0000715256,
    y1: 1080,
    x2: 1316.78,
    y2: -502.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1089ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1089ff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2492_14458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2492_14458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 284,
    height: 284,
    fill: "white",
    transform: "translate(-112 896)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2492_14458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 137,
    fill: "white",
    transform: "translate(1763 749)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.fbe37eed5007e21a5e0aca7bc92339f5.svg";
export { ForwardRef as ReactComponent };